import { faCircleInfo, faInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { forwardRef } from "react";
import { Tooltip } from "react-tooltip";
import { IconsRenderer } from "../../assets/icon-pack";

const ProgressInput = forwardRef(
  ({ label, value, color = "red", description = "", index }, ref) => (
    <div ref={ref} className="flex flex-col gap-2">
      {label ? (
        <div className="flex items-end justify-between">
          <div className="flex gap-2 items-center mr-2">
            <IconsRenderer
              name="Info"
              id={`info-btn-${index}`}
              icon={faCircleInfo}
              color="gray"
              style={{
                color: "#6237EC",
              }}
              size="xs"
              className="cursor-pointer w-[15px] h-[15px]"
            />
            <h5 className="text-xs text-ui-arrow">{label}</h5>
            <Tooltip
              style={{ pointerEvents: "auto" }}
              id={`info-btn-${index}`}
              className="!opacity-100 !bg-white !text-black !border-[1px] !text-xs !w-44 !rounded-[21px]"
              anchorSelect={`#info-btn-${index}`}
              // isOpen={true}
            >
              {description}
            </Tooltip>
          </div>
          <span className="text-[.5rem] font-bold" style={{ color: color }}>
            {value}%
          </span>
        </div>
      ) : (
        ""
      )}
      <div className="w-full bg-ui-range flex rounded-full">
        <div
          className={`h-1 rounded-full`}
          style={{ width: `${value}%`, backgroundColor: color }}
        ></div>
      </div>
      {/* {description && (
        <div>
          <p className="text-[.625rem] text-ui-arrow">{description} </p>
        </div>
      )} */}
    </div>
  ),
);
ProgressInput.displayName = "ProgressInput";
export default ProgressInput;
